module.exports = __webpack_public_path__ + "static/ttl-80g-certificate-1a5a993895c4a015759bb0140ff154d2.pdf";